import { MobileDataService } from "utils/enums/MobileDataEnums";
import {
  PackageCategoryEntity,
  PackageCountryEntity,
  PackageLookupEntity,
  PackageSupplierEntity,
} from "./PackageLookupEntity";
import { PackageDetailEntity, PackageMoreEntity } from "./PackageResponseEntity";

export class PackageActionRequestEntity {
  id?: string;
  name?: string;
  code?: string;
  cover?: string;
  carrier?: string;
  description?: string;
  categories?: Array<{ label?: string; value?: string }> | string[];
  durationDay?: number;
  price?: string;
  storage?: number;
  discountRate?: string;
  internalCallTotalHour?: number;
  externalCallTotalHour?: number;
  shortDescription?: string[];
  more?: PackageMoreEntity[];
  order?: number;
  type?: number;
  simType?: number;
  suppliers?: Array<string | PackageSupplierEntity>;
  capacityUnit?: string;
  durationUnit?: string;
  countries?: PackageCountryEntity[] | string;
  constructor(data?: Partial<PackageActionRequestEntity>) {
    Object.assign(this, data);
  }
}

export class PackageCreateRequestEntity {
  service?: MobileDataService;
  travelSimMobileData?: PackageActionRequestEntity;
  ecommerceSimMobileData?: PackageActionRequestEntity;
  mobileData?: PackageActionRequestEntity;

  constructor(data?: Partial<PackageCreateRequestEntity>) {
    Object.assign(this, data);
  }
}

export class PackageSupplierAdditionRequestEntity {
  id?: string;
  suppliers?: PackageLookupEntity[];

  constructor(data?: Partial<PackageSupplierAdditionRequestEntity>) {
    Object.assign(this, data);
  }
}

export class PackageCategoryAdditionRequestEntity {
  id?: string;
  categories?: PackageCategoryEntity[];

  constructor(data?: Partial<PackageCategoryAdditionRequestEntity>) {
    Object.assign(this, data);
  }
}

export class PackageActionCommandEntity {
  body?: PackageActionRequestEntity;
  action?: "update" | "create";
  service?: MobileDataService;
  detailInfo?: PackageDetailEntity;
  chosenSupplier?: PackageSupplierEntity[];
  categoryList?: PackageCategoryEntity[];
  typeKey?: string;

  constructor(data?: Partial<PackageActionCommandEntity>) {
    Object.assign(this, data);
  }
}
